import React from 'react';
import Icon from '../Icon';
import { formatAmount } from '../../hooks/useInsightsData';

/**
 * 분석 요약 카드 컴포넌트
 * 재정현황, 지출패턴, 재정조언을 시각적 계층으로 제공한다.
 *
 * @param {Object} props
 * @param {Object} props.summaryData - useInsightsData에서 반환된 summaryData
 */
const SummaryCard = ({ summaryData }) => {
  const {
    balance,
    savingsRate,
    avgMonthlyIncome,
    avgMonthlyExpense,
    topCategory,
    advice,
  } = summaryData;

  const isPositiveBalance = balance >= 0;

  return (
    <div className="insights-card summary-card">
      <h3 className="insights-card__title">분석 요약</h3>

      {/* 핵심 수치 — 크게 강조 */}
      <div className="summary-card__hero">
        <div className={`summary-card__hero-amount ${isPositiveBalance ? 'summary-card__hero-amount--positive' : 'summary-card__hero-amount--negative'}`}>
          <span className="summary-card__hero-label">
            {isPositiveBalance ? '총 저축액' : '총 적자액'}
          </span>
          <span className="summary-card__hero-value">
            {formatAmount(Math.abs(balance))}원
          </span>
          <span className="summary-card__hero-rate">
            저축률 {savingsRate}%
          </span>
        </div>
      </div>

      {/* 월평균 수입/지출 — 2열 미니 카드 */}
      <div className="summary-card__monthly">
        <div className="summary-card__monthly-item">
          <Icon name="trending_up" size={16} />
          <span className="summary-card__monthly-label">월평균 수입</span>
          <span className="summary-card__monthly-value summary-card__monthly-value--income">
            {formatAmount(avgMonthlyIncome)}원
          </span>
        </div>
        <div className="summary-card__monthly-item">
          <Icon name="trending_down" size={16} />
          <span className="summary-card__monthly-label">월평균 지출</span>
          <span className="summary-card__monthly-value summary-card__monthly-value--expense">
            {formatAmount(avgMonthlyExpense)}원
          </span>
        </div>
      </div>

      {/* 지출패턴 (지출 없으면 숨김) */}
      {topCategory && (
        <div className="summary-card__pattern">
          <Icon name="category" size={16} />
          <span className="summary-card__pattern-text">
            최다 지출: <strong>{topCategory.name}</strong> ({topCategory.percentage}%)
          </span>
        </div>
      )}

      {/* 재정조언 */}
      <div className={`insights-summary-advice insights-summary-advice--${advice.type}`}>
        <Icon name={advice.type === 'positive' ? 'thumb_up' : advice.type === 'warning' ? 'warning' : 'lightbulb'} size={16} />
        <span>{advice.message}</span>
      </div>
    </div>
  );
};

export default SummaryCard;
